module.exports = __webpack_public_path__ + "stylesheets/company_da04918b4314bfdfb31bc570653066b4.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/company.less
// module id = 6bdG
// module chunks = 55